// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"6c03d9a1","254":"d0b04dde"}[chunkId] + ".chunk.css";
};